import { PageComponents, ButtonType, AjaxResponse } from '@my-types';
import { React, Styled } from '@common/3rd';
import { Ajax, PATH, Apis, Codes, Utils, Storage, Envs } from '@common';
import { DeskPage, DeskPageBody, DeskButton } from './component';
import InfiniteScrolling from '@component/infinite-scrolling'
import Dialog from '@component/dialog'
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { StyledComponents } from '@styles';
import PL_IMG from '@images/pic_pl.jpg';
import GTA_IMG from '@images/pic_gta.jpg';
import COMINGSOON from '@images/comingsoon.png';
const DISABLED_PRO: {[propName: string]: string[]} = {
	CPIC: ['GTA'],
	PINGAN: ['PL', 'GTA']
}
const PLPDFUrl = 'http://csms-pu.oss-cn-shanghai.aliyuncs.com/rmcp/Product/%E5%AF%B9%E5%A4%96%E8%B4%B8%E6%98%93%E5%87%BA%E5%8F%A3%E4%BA%A7%E5%93%81%E8%B4%A3%E4%BB%BB%E4%BF%9D%E9%99%A9%E8%AF%B4%E6%98%8E_v2.pdf';
const GTAPDFUrl = 'http://csms-pu.oss-cn-shanghai.aliyuncs.com/rmcp/Product/%E5%AF%B9%E5%A4%96%E8%B4%B8%E6%98%93%E6%B5%B7%E5%A4%96%E5%87%BA%E5%B7%AE%E6%B4%BE%E9%A9%BB%E4%BA%BA%E5%91%98%E6%84%8F%E5%A4%96%E4%BF%9D%E9%99%A9%E8%AF%B4%E6%98%8E_v2.pdf';
const productDesc: {[propName: string]: string[]} = {
    PL: [
        '本保险承保由于产品设计或制造上的缺陷、产品使用说明不完整、警告提示遗漏等原因，被保险人所生产、出售或供销的产品或商品在保险单中载明的承保区域内发生事故，造成使用、消费或操作该产品或商品的人或其他任何人的人身伤亡、疾病或财产损失，依法应由被保险人承担的经济赔偿责任。',
        '譬如，下面这些事故可以保险赔偿：',
        '・电视机自燃后将房屋烧毁。' ,
        '・电路板接线不良，造成后道工序加工商大量配件报废（※不良完成品事故，须附加扩展条款）。'
    ],
    GTA: [
        '本保险对海外出差派驻人员遭受意外伤害事故导致身故、伤残的进行保险金赔偿。另外，保险人向被保险人提供紧急救援，境外治疗，亲属探访，安排随行未成年人回国，医疗转运等服务，并承担相应费用。',
        '譬如，下述事故可以保险赔偿：',
        '・航空意外导致身故。',
        '・发生交通事故需要住院治疗。'
    ]
}
const ScrollingWrapper = Styled.div`
	margin: 0 -15vw;
	padding: 0 15vw;
	background: #FFFFDC;
`
const Panel = Styled.div`
display: flex;
padding: 20px 0;
&:not(:last-child) {
	border-bottom: 1px dashed #ddd;
}
img {
	height: fit-content;
}
& > div {
	flex: 1;
	display: flex;
	flex-direction: column;
	padding-left: 20px;
	p {
		margin-bottom: 4px;
	}
	.desc {
		line-height: 1.8;
        margin-bottom: 5px;
        width: 75%;
	}
	& [data-icon] {
		color: ${props => props.theme.COLOR_PRIMARY};
	}
	.title {
		font-size: ${props => props.theme.FONT_SIZE_LARGE}px;
		font-weight: bold;
	}
	[data-widget=button-bar] {
		margin-top: auto;
	}
}
`;
const Container = Styled.div`
display: flex;
flex-direction: column;
margin: 0 auto;
width: calc(100vw - 300px);
`;
const PanelBottom = Styled.div`
display: flex;
justify-content: space-between;
margin-top: auto;
& a:first-child {
	color: ${props => props.theme.COLOR_PRIMARY};
	cursor: pointer;
}
`;
const QuoteBtn = Styled(StyledComponents.BUTTON)`
background: ${props => props.theme.COLOR_PRIMARY};
color: ${props => props.theme.COLOR_REVERSED};
width: 120px;
`;
const DialogWrapper = Styled.div`
	padding: 20px;
	p {
		text-align: center;
	}
	.coming {
		display: flex;
		align-items: center;
    	justify-content: center;
		img {
			width: 120px;
		}
		p {
			margin-left: 10px;
			line-height: 2;
		}
	}
`;
type Product = {
	productName: string,
	productCode: string,
	img?: string,
	description?: string | any[],
	pdfUrl?: string
}
interface MyState {
	productList: Product[],
	messageList: any[]
}
/**
 * 桌面首页
 */
class DeskHome extends DeskPage<any, MyState, PageComponents> {
	dialog: any;
	constructor(props: any) {
		super(props);
		this.state = {
			productList: [],
			messageList: []
		};
		this.dialog = React.createRef();
	}
	renderPageBody() {
		return (
			<DeskPageBody>
				<Container>
					{Ajax.isAuthorized() && this.state.messageList.length ?
						<ScrollingWrapper>
							<InfiniteScrolling items={this.state.messageList} icon={faVolumeUp} color="warn" />
						</ScrollingWrapper> : null
					}
					{(this.state.productList as Product[]).map(product =>
						(<Panel key={product.productCode}>
							<img src={product.img} alt="" />
							<div>
								<p className="title">{product.productName}</p>
                                {product.description && product.description.length ?
                                (product.description as any[]).map((desc, index) => <p className="desc" key={+new Date() + index}>{desc}</p>) : ''}
								{/* {product.details ? product.details.map((detail, i) => (
									<p key={i}><FontAwesomeIcon icon={faPlay} /> {detail}</p>
								)) : null} */}
								<PanelBottom>
									{product.pdfUrl ? <a onClick={() => {
										// this.viewDetail(product);
										window.open(product.pdfUrl, '_blank');
									}}>点击查看产品介绍</a> : null}
									{Envs.isTenantAdmin() ? null : <QuoteBtn onClick={() => this.onQuoteClick(product)}>立即投保</QuoteBtn>}
								</PanelBottom>
							</div>
						</Panel>)
					)}
				</Container>
			</DeskPageBody>
		);
	}
	private onQuoteClick = (selectedProduct: Product): void => {
		if (Ajax.isAuthorized()) {
			if (!Storage.Last.session().get('vendor')) {
				this.getHelpers().getRouter().pushRedirect(PATH.RISK_WARNING_MAIN);
			} else {
				this.onGoQuoteClick(selectedProduct.productCode, Storage.Last.session().get('vendor'));
			}
		} else {
			this.dialog = Dialog.show('提示',
			<DialogWrapper>
				<p>您尚未登录，先前往登录？</p>
			</DialogWrapper>,
			<DeskButton type={ButtonType.PRIMARY} onClick={this.onSignin}>确认</DeskButton>,
			{boxCSS: { width: '300px', top: '20vh' }})
		}
	}
	private onSignin = () => {
		Dialog.hide(this.dialog);
		this.getHelpers().getRouter().pushRedirect(PATH.DESK_SIGN_IN);
	}
	private onGoQuoteClick = (code: any, vendorCode: any): void => {
		vendorCode = vendorCode.replace('_GI', ''); // ?
		if (DISABLED_PRO[vendorCode] && DISABLED_PRO[vendorCode].some(c => code.includes(c))) {
			let dialog = Dialog.show('提示',
			<DialogWrapper>
				<div className="coming">
					<img src={COMINGSOON} alt="comingsoon"/>
					<p>产品开发中，<br />敬请期待！</p>
				</div>
			</DialogWrapper>,
			<DeskButton type={ButtonType.PRIMARY} onClick={() => {Dialog.hide(dialog)}}>关闭</DeskButton>,
			{boxCSS: { width: '300px', top: '20vh' }})
		} else {
			// 产责跳问卷，海旅跳投保
			let	path = (code.includes('PL') ? PATH.DESK_PRODUCT_QUESTIONNAIRE : PATH.DESK_PRODUCT_QUOTE).replace(':vendorCode', vendorCode).replace(':productCode', `${code}_${vendorCode}`).replace(':step', '1');
			this.getHelpers().getRouter().pushRedirect(path);
		}
	}
	private handleItems(items: (any)[]) {
		let productList: Product[] = [];
		items.forEach(item => {
            let keyInDesc = (Object.keys(productDesc) as any[]).find(key => item.productCode.includes(key));
            item.productName = keyInDesc === 'PL' ? '出口产品责任险' : '境外旅行意外险';
			item.img = keyInDesc === 'PL' ? PL_IMG : GTA_IMG;
			item.pdfUrl = keyInDesc === 'PL' ? PLPDFUrl : GTAPDFUrl;
			item.pdfUrl = item.pdfUrl.replace(/http:|https:/, window.location.protocol);
			let vendorItem = (Codes.TENANT_NAME as {[propName: string]: string}[]).find(item => item.v.includes(item.vendorCode));
			if (vendorItem) {
				item.vendorName = vendorItem.l;
			}
			if (!productList.some(p => p.productName === item.productName)) {
                let lastIndex = item.productCode.lastIndexOf('_');
				productList.push({
					productName: item.productName,
                    productCode: item.productCode.slice(0, lastIndex),
                    description: productDesc[keyInDesc],
					img: item.img,
					pdfUrl: item.pdfUrl
				})
			}
		});
		return {
			productList
		}
	}
	componentDidMount() {
		let qs = Utils.fromQueryString(),
			host = window.location.host.toLowerCase(),
			vendor = '';
		if (host.includes('picc')) {
			vendor = 'PICC';
		} else if (host.includes('cpic')) {
			vendor = 'CPIC';
		} else if (host.includes('paic')) {
			vendor = 'PINGAN';
		} else if (qs.vendor) {
			vendor = qs.vendor;
		}
		if (vendor) {
			Storage.Last.session().set('vendor', vendor)
		}
	  	this.getHelpers().getAjax().get(Apis.HOME_PRODUCTS).then((response: AjaxResponse) => {
			if (response.body?.body?.items?.length) {
                let {productList} = this.handleItems(response.body.body.items);
				this.setState({
					productList
				});
			}
		});
		if (Ajax.isAuthorized()) {
			this.getHelpers().getAjax().get(Apis.GET_MESSAGE_LIST).then((response: AjaxResponse) => {
				if (response.body?.body && response.body?.body.length) {
					this.setState({
						messageList: (response.body.body as any[]).filter(item => item.messageContext).map(item => item.messageContext)
					});
				}
			})
		}
	}
}

export default DeskHome;
